import {
  LightDraw,
  VERSION,
  use,
  createApp,
  App,
  Node,
  Group,
  Layer,
  Rect,
  Circle,
  Ellipse,
  Line,
  Arc,
  Polygon,
  Polyline,
  Path,
  Star,
  RoundedRect,
  TextNode,
  ImageNode,
  Sprite,
  Camera,
  CanvasRenderer,
  Renderer,
  animate,
  AnimationEngine,
  Timeline,
  parallel,
  easings,
  getEasing,
  registerEasing,
  Layout,
  fromJSON,
  toJSON,
  registerJSONType,
  exportScene,
  exportApp,
  downloadExport,
  validateSceneJSON,
  parseAndValidateSceneJSON,
  formatJsonParseError,
  locateJsonError,
  formatValidationErrors,
  validateThemePack,
  listKnownSceneTypes,
  formatExpectedValues,
  formatInvalidValue,
  suggestClosest,
  scenesEqual,
  createPluginContext,
  getInstalledPlugins,
  Matrix2D,
  ObjectPool,
  detectBestRenderer,
  EventEmitter,
  compactSceneJSON,
} from './core/index';

import { svgPlugin, SVGRenderer } from './modules/svg';
import { htmlPlugin, HTMLRenderer } from './modules/html';
import { uiPlugin, registerComponent, createComponentFromJSON } from './modules/ui';
import { dashboardPlugin, registerDashboard, createDashboardFromJSON, animateLiveValue, setLiveValue, updateChartProps, pushChartValue, installChartResizeObserver, detachChartResizeObserver } from './modules/dashboard';
import {
  automotivePlugin,
  registerAutomotive,
  createAutomotiveFromJSON,
  applyDriveState,
  sampleDriveFrames,
  animateAutoValue,
  setAutoValue,
  installAutoWidgetResizeObserver,
  detachAutoWidgetResizeObserver,
  updateAutoWidgetProps,
  listAutomotiveWidgets,
} from './modules/automotive';
import { diagramPlugin, Diagram } from './modules/diagram';
import { applyUiTheme, resolveUiTheme, UI_PRESETS, UI_THEME_VAR_MAP, UI_DARK_PACK, UI_LIGHT_PACK, UI_DARK_MODE_PACK, UI_LIGHT_MODE_PACK } from './components/uiTheme';
export type { UiThemeTokens, UiThemeInput, UiThemePreset } from './components/uiTheme';
import {
  normalizeThemePack,
  mergeThemePacks,
  splitThemePack,
  extractSceneTheme,
  composeThemePack,
} from './theme/themePack';
export {
  normalizeThemePack,
  mergeThemePacks,
  splitThemePack,
  extractSceneTheme,
  composeThemePack,
};
export type { ThemePack, DiagramThemePack } from './theme/themePack';

export { VERSION };

use(svgPlugin);
use(htmlPlugin);
use(uiPlugin);
use(automotivePlugin);
use(dashboardPlugin);
use(diagramPlugin);

export const LightDrawFull = Object.assign(LightDraw, {
  SVGRenderer,
  HTMLRenderer,
  registerComponent,
  createComponentFromJSON,
  registerDashboard,
  createDashboardFromJSON,
  animateLiveValue,
  setLiveValue,
  updateChartProps,
  pushChartValue,
  installChartResizeObserver,
  detachChartResizeObserver,
  registerAutomotive,
  createAutomotiveFromJSON,
  applyDriveState,
  sampleDriveFrames,
  animateAutoValue,
  setAutoValue,
  installAutoWidgetResizeObserver,
  detachAutoWidgetResizeObserver,
  updateAutoWidgetProps,
  listAutomotiveWidgets,
  Diagram,
  applyUiTheme,
  resolveUiTheme,
  UI_PRESETS,
  UI_THEME_VAR_MAP,
  UI_DARK_PACK,
  UI_LIGHT_PACK,
  UI_DARK_MODE_PACK,
  UI_LIGHT_MODE_PACK,
  normalizeThemePack,
  mergeThemePacks,
  extractSceneTheme,
});

export {
  use,
  createApp,
  App,
  Node,
  Group,
  Layer,
  Rect,
  Circle,
  Ellipse,
  Line,
  Arc,
  Polygon,
  Polyline,
  Path,
  Star,
  RoundedRect,
  TextNode,
  ImageNode,
  Sprite,
  Camera,
  CanvasRenderer,
  SVGRenderer,
  HTMLRenderer,
  Renderer,
  animate,
  AnimationEngine,
  Timeline,
  parallel,
  easings,
  getEasing,
  registerEasing,
  Layout,
  Diagram,
  fromJSON,
  toJSON,
  compactSceneJSON,
  registerJSONType,
  exportScene,
  exportApp,
  downloadExport,
  validateSceneJSON,
  parseAndValidateSceneJSON,
  formatJsonParseError,
  locateJsonError,
  formatValidationErrors,
  validateThemePack,
  listKnownSceneTypes,
  formatExpectedValues,
  formatInvalidValue,
  suggestClosest,
  scenesEqual,
  registerComponent,
  createComponentFromJSON,
  registerDashboard,
  createDashboardFromJSON,
  registerAutomotive,
  createAutomotiveFromJSON,
  applyDriveState,
  sampleDriveFrames,
  animateAutoValue,
  setAutoValue,
  installAutoWidgetResizeObserver,
  detachAutoWidgetResizeObserver,
  updateAutoWidgetProps,
  listAutomotiveWidgets,
  animateLiveValue,
  setLiveValue,
  updateChartProps,
  pushChartValue,
  installChartResizeObserver,
  detachChartResizeObserver,
  createPluginContext,
  getInstalledPlugins,
  Matrix2D,
  ObjectPool,
  detectBestRenderer,
  EventEmitter,
  svgPlugin,
  htmlPlugin,
  uiPlugin,
  dashboardPlugin,
  automotivePlugin,
  diagramPlugin,
  applyUiTheme,
  resolveUiTheme,
  UI_PRESETS,
  UI_THEME_VAR_MAP,
  UI_DARK_PACK,
  UI_LIGHT_PACK,
  UI_DARK_MODE_PACK,
  UI_LIGHT_MODE_PACK,
};

export { LightDrawFull as LightDraw };
export default LightDrawFull;

if (typeof window !== 'undefined') {
  (window as unknown as { LightDraw: typeof LightDrawFull }).LightDraw = LightDrawFull;
}
